<template>
<form class="p-capture-form">
  <div class="p-capture-form__wrapper">
    <dl class="p-capture-form__item">
      <dt class="p-capture-form__item-label">
        <Text className="c-text-s__bold" text="サイトURL"></Text>
        <Text className="c-text-s__error" :text="error.url"></Text>
      </dt>
      <dd class="p-capture-form__item-input">
        <MyInput type="url"
          className="c-input__url"
          @change="handleUrl"
          :value="url"
          placeholder="https://worksthumbnailgenerator">
        </MyInput>
      </dd>
    </dl>
    <dl class="p-capture-form__item">
      <dt class="p-capture-form__item-label">
        <Text className="c-text-s__bold" text="背景色"></Text>
        </dt>
      <dd class="p-capture-form__item-input">
        <MyInput
          type="color"
          className="c-input__color"
          @change="handleBgColor"
          :value="bgColor">
        </MyInput>
      </dd>
    </dl>
  </div>
  <div class="p-capture-form__btn">
    <Button
      @click="capture"
      :className="['c-btn__primary--l-popup', 'gtm-generate-url', returnGenerateModeAsString, isBtnError ? '--disabled' : '']"
      :disabled="isBtnError"
      type="button"
      dataType="url"
      text="これでつくる！">
    </Button>
  </div>
  <Text className="c-text-s__error mt20 taC" v-show="errorAxios.isError" :text="errorAxios.msg"></Text>
</form>
</template>

<script>
import Store from '@/store/index.js'
import Text from '@/components/atoms/Text.vue'
import MyInput from '@/components/atoms/MyInput.vue'
import Button from '@/components/atoms/Button.vue'

export default {
  name: 'TabContentsCaptureUrlForm',
  components: {
    Text,
    MyInput,
    Button
  },
  props: {
    errorAxios: Object
  },
  data () {
    return {
      url: Store.state.url,
      bgColor: Store.state.bgColor,
      error: {
        url: null
      }
    }
  },
  computed: {
    returnGenerateModeAsString () {
      const url = Store.state.url
      const bgColor = Store.state.bgColor
      let ptn = String
      Store.state.thumbnailType.p1 ? ptn = 'p1' : ptn = 'p2'
      return `${ptn}-${url}-${bgColor}`
    },
    isBtnError () {
      return Store.state.errors.btn
    }
  },
  methods: {
    capture (e) {
      this.$emit('capture', e)
    },
    handleUrl (e) {
      Store.commit('handleAxiosError', false)
      Store.commit('handleBtnError', false)
      const regex = new RegExp('^(https?:\\/\\/)' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i')
      if (regex.test(e.target.value)) {
        this.error.url = ''
        Store.commit('handleBtnError', false)
        Store.commit('handleUrl', e)
        Store.commit('handleUrlChangeFlag', true)
      } else {
        this.error.url = 'URLが正しいか確認してください！'
        Store.commit('handleBtnError', true)
      }
    },
    handleBgColor (e) {
      Store.commit('handleBgColor', e)
    }
  }
}

</script>

<style lang="scss" scoped>
.p-capture {
  &-form {
    &__wrapper {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      @include media-queries-sp {
        display: block;
      }
    }
    &__item {

      &-label {
        margin-bottom: 5px;
        padding-left: 15px;
        display: flex;
      }
    }
    &__btn {
      margin-top: 30px;
    }
  }
}
</style>
